import React from "react";
import ScheduleUploadTable from "./ScheduleUploadTable";
import {PatternBackground} from "../../components/PatternBackground";

export const DashboardPage = () => {
  return (
      <div className="">
        <PatternBackground>
          <h1 className="fw-bold mb-3">Dashboard</h1>
          <small>Monitor your pension contributions and system activities</small>
        </PatternBackground>
        <div className="om-container">
          <div className='p-4 shadow-sm bg-white rounded'>
              <ScheduleUploadTable />
          </div>
        </div>
      </div>
  )
}
